import moment from "moment";

export function formatDate(date) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${day.substring(0, 2)}/${month}/${year}`;
}

export function reformatDate(date) {
    if (!date) return null;
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
}

export function parseDate(date) {
    if (!date) return null;
    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export function formatDateLabel(value) {
    if (!value) return "";
    const candidate = moment(value, [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm:ssZ"], true);
    if (candidate.isValid()) {
        return candidate.format("DD/MM/YYYY");
    }
    const fallback = moment(value);
    return fallback.isValid() ? fallback.format("DD/MM/YYYY") : value;
}

export function formatDateTimeLabel(value) {
    if (!value) return "";
    const candidate = moment(value, [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm:ssZ"], true);
    if (candidate.isValid()) {
        return candidate.format("DD/MM/YYYY HH:mm");
    }
    const fallback = moment(value);
    return fallback.isValid() ? fallback.format("DD/MM/YYYY HH:mm") : value;
}

export function getCtrlDateTime(dateCtrlValue, timeCtrlValue) {
    const datetimeRslt = new Date(dateCtrlValue);
    const [hours = "0", minutes = "0"] = (timeCtrlValue || "").split(":");
    datetimeRslt.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);
    return datetimeRslt;
}

export function setCtrlDate(datetimeString) {
    const da = new Date(datetimeString);
    return `${da.getFullYear()}-${(da.getMonth() + 1).toString().padStart(2, "0")}-${da.getDate().toString().padStart(2, "0")}`;
}

export function setCtrlTime(datetimeString) {
    const da = new Date(datetimeString);
    return `${da.getHours().toString().padStart(2, "0")}:${da.getMinutes().toString().padStart(2, "0")}`;
}

export function dateToISOString() {
    // intentionally left blank
}